import { Component } from '@angular/core';
import { Router } from '@angular/router';

import {
    Animations,
    AntragResponse,
    BackendOberflaecheService,
    BausteinBeitrag,
    DownloadService,
    Helper,
    OberflaecheElement,
    RateService,
    SetAntragProvider,
    StandardBeitragComponent,
    TarifierungResponse
} from '@vhv/tarifrechner-common';

import { SendeAntragsdatenCyberService } from '../../service/sende-antragsdaten-cyber.service';
import { BehaviorSubject } from 'rxjs';

@Component({
    animations: [Animations.slideInDownAnimation],
    templateUrl: 'cyber-zusammenfassung.component.html',
})
export class CyberZusammenfassungComponent extends StandardBeitragComponent {

    isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public foo = true;

    public currentRate: TarifierungResponse;

    constructor(
        public rateService: RateService,
        private _inputRouter: Router,
        private _inputBackendOberflaecheService: BackendOberflaecheService,
        private _setAntragProvider: SetAntragProvider,
        private sendeAntragsdatenService: SendeAntragsdatenCyberService,
        private _downloadService: DownloadService
    ) {
        super(
        );

        if (this._inputBackendOberflaecheService.getElementByName('IstDirektionsanfrage').value === 'false') {
            this.rateService.registerCallback(this.updateRate);
            this.rateService.calculateBeitrag();
        } else {
            this.currentRate = null;
        }

    }

    onSubmit() {
        this.isLoading.next(true);
        this._setAntragProvider.setAntrag(this.sendeAntragsdatenService.getAntragRequest())
            .then((value: AntragResponse) => {
                this._downloadService.setAntragskopie(value.dateien[0].inhalt);
                super.onSubmit();
                this.isLoading.next(false);
            })
            .catch(() => {
                this._inputRouter.navigate(['/error']);
                this.isLoading.next(false);
            });
    }

    getSubmitButtonText(): string {
        if (this._inputBackendOberflaecheService.getElementByName('IstDirektionsanfrage').value === 'false') {
            return 'Jetzt beitragspflichtig abschließen';
        }

        return 'Jetzt Anfrage stellen';
    }

    updateRate = (newRate: TarifierungResponse): void => {
        this.currentRate = newRate;
    };

    getOberflaechenElementWert(element: string): string {
        return this._inputBackendOberflaecheService.getElementByName(element).value;
    }

    getVersicherungsbeginn(): string {
        if (this.getOberflaechenElementWert('Versicherungsbeginn')) {
            return Helper.dateStringToDeLocaleString(this.getOberflaechenElementWert('Versicherungsbeginn'));
        }
        return '';
    }

    getOberflaechenElementEintraegeWert(elementName: string): string {
        const element: OberflaecheElement = this._inputBackendOberflaecheService.getElementByName(elementName);
        return element.oberflaecheWerteEintraege.find((value: any) => {
            return (value.inhalt === element.value);
        }).anzeige;
    }

    isFirma(): boolean {
        return (this._inputBackendOberflaecheService.getElementByName('Antragsteller').value == '2');
    }

    getBausteine(): Map<string, BausteinBeitrag> {
        const result: Map<string, BausteinBeitrag> = new Map(this.currentRate.beitraegeFuerBausteine);
        result.delete('Grundbaustein');
        return result;
    }

    getBausteinBezeichnungen(bausteinKey: string): string {
        const bausteinElement = this._inputBackendOberflaecheService.getElementByName('Baustein' + bausteinKey);

        if (bausteinElement) {
            return bausteinElement.attribut.label
        }

        return '';
    }

}
